export default __webpack_public_path__ + "static/marketing-734eed15be05ca89f18adac771f42c97.png";